import {AdvancedSearchFilterModel} from "../../search/models/advanced-search-filter";
import {backboneCollectionProperties} from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: AdvancedSearchFilterModel
})
export class FiltersCollection extends Backbone.Collection<AdvancedSearchFilterModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/filters.ts